const s = {
  name: "Acting",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24,33c0-2.2,1.8-4,4-4s4,1.8,4,4h2c0-3.3-2.7-6-6-6s-6,2.7-6,6H24z"/>
		<path class="st0" d="M25,25.2c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C23.8,24.7,24.3,25.2,25,25.2z"
			/>
		<path class="st0" d="M32.3,24c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C31.7,22.8,32.3,23.3,32.3,24z"
			/>
		<path class="st0" d="M12,18c-2.2,0-4-1.8-4-4H6c0,3.3,2.7,6,6,6s6-2.7,6-6h-2C16,16.2,14.2,18,12,18z"/>
		<path class="st0" d="M9,11.2c0.7,0,1.3-0.6,1.3-1.2c0-0.7-0.6-1.2-1.3-1.2c-0.7,0-1.2,0.6-1.2,1.2C7.7,10.7,8.3,11.2,9,11.2z"/>
		<path class="st0" d="M16.3,10c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C15.7,8.8,16.3,9.3,16.3,10z"/>
		<path class="st0" d="M24,0H0v14c0,6.6,5.4,12,12,12c1.4,0,2.7-0.2,4-0.7V28c0,6.6,5.4,12,12,12s12-5.4,12-12V14H24V0z M18,28v-3.6
			c3-1.8,5.2-4.8,5.8-8.4H38v12c0,5.5-4.5,10-10,10S18,33.5,18,28z M2,14V2h20v12c0,5.5-4.5,10-10,10C6.5,24,2,19.5,2,14z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Acting
};
